export default "__VITE_ASSET__Ws6zBZuQ__"